export interface IQipReport {
  m_id: string;
  m_yr: number;
  hosp_id: number;
  m_prov: number;
  m_nbr1: number;
  m_nbr2: number;
  m_nbr3: number;
  m_nbr4: number;
  m_lname: string;
  m_fname: string;
  m_mi: string;
  m_dob: string;
  m_gender: string;
  m_samp: number;
  m_elemt: string;
  svc_dt: string;
  admt_dt: string;
  dich_dt: string;
  bp_tm: string;
  bg_tm: string;
  ed_tm: string;
  res_val: string;
  code_val: string;
  res_valp: string;
  toba_t: string;
  toba_s: string;
  toba_i: string;
  alcs_t: string;
  alcs_s: string;
  alcs_i: string;
  drug_t: string;
  drug_s: string;
  drug_i: string;
  deps_t1: string;
  deps_o1: string;
  deps_s1: string;
  incl_t: string;
  incl_s: string;
  incl_i: string;
  nullip: string;
  vertex: string;
  bp_syst: string;
  bp_dias: string;
  ed_othtx: string;
  dmode: string;
  ctms_i: string;
  ctms_e: string;
  ctms_s: string;
  sdoh_t: string;
  sdoh_r1: string;
  sdoh_i1: string;
  sdoh_r2: string;
  sdoh_i2: string;
  sdoh_r3: string;
  sdoh_i3: string;
  sdoh_r4: string;
  sdoh_i4: string;
  sdoh_r5: string;
  sdoh_i5: string;
  race: string;
  ethnic: string;
  eof_id: string;
  is_manually_updated: boolean;
  updated_by: number;
  last_updated_date: Date | string;
  totalItems: number;
}

export class IQipPerformance {
  measureId: number;
  measureCode: string;
  measureName: string;
  contract1Performance: number;
  contract2Performance: number;
}
